import Entity from './entity'
import CreateQuestionnaireInput from './createQuestionnaireInput'
import CreateQuestionBanks from './createQuestionBanks'

export default class Questionnaire extends Entity<string>{
    createQuestionnaireInput:CreateQuestionnaireInput=new CreateQuestionnaireInput();
    createQuestionBanks:Array<CreateQuestionBanks>;
}